import {
  DateFormat,
  formatCurrency,
  formatDate,
  goalYearOf,
} from "../../../utils";
import { MISSING_VALUE, OUTCOME_LABEL, OUTCOME_TONE } from "./constants";
import { PastSavingsGoalLineProps } from "./types";
import { LinkActions, PastAmount, PastLine, StatusChip } from "./styles";
import Button, { ButtonTypes } from "../../../components/Button";

export const PastSavingsGoalLine = ({
  goal,
  onDelete,
}: PastSavingsGoalLineProps) => {
  const year = goalYearOf(goal);
  const savedAmount =
    goal.closedAmount === null
      ? MISSING_VALUE
      : formatCurrency(goal.closedAmount);
  const deadline = formatDate(goal.targetDate, DateFormat.DMY_SPACE);
  const deleteLabel = `Delete ${goal.name} ${year}`;
  const outcomeChip = goal.outcome ? (
    <StatusChip $tone={OUTCOME_TONE[goal.outcome]}>
      {OUTCOME_LABEL[goal.outcome]}
    </StatusChip>
  ) : null;

  return (
    <PastLine data-testid="past-savings-goal">
      <PastAmount>{year}</PastAmount>
      <span>Target {formatCurrency(goal.targetAmount)}</span>
      <PastAmount>Saved {savedAmount}</PastAmount>
      {outcomeChip}
      <span>Deadline {deadline}</span>
      <LinkActions>
        <Button
          type={ButtonTypes.link}
          size="small"
          tone="danger"
          aria-label={deleteLabel}
          onClick={() => onDelete(goal)}
        >
          Delete
        </Button>
      </LinkActions>
    </PastLine>
  );
};
